declare var require: any;

try {
    const context = (require as any).context('.', true, /\.ts$/);
    context.keys().forEach((key: string) => {
        if (key !== './index.ts') {
            context(key);
        }
    });
} catch (e) {
    console.warn("Auto-registration of services failed:", e);
}
